import './ChallengeSection.css';
import forkAndSpoon from '../assets/fork-and-spoon.png';
import night from '../assets/night.png';
import navigator from '../assets/navigator.png';
import theDistanceImage from '../assets/the_distance.png';

const challengeStats = [
  {
    id: 'distance',
    value: '3,000',
    label: 'Nautical Miles of Ocean',
    icon: 'pin'
  },
  {
    id: 'duration',
    value: '50',
    label: 'Days at Sea',
    icon: 'calendar'
  },
  {
    id: 'waves',
    value: '50-foot',
    label: 'Waves',
    icon: 'waves'
  },
  {
    id: 'rowing',
    value: '16 hours',
    label: 'of rowing per DAY',
    icon: 'hourglass'
  }
];

const icons = {
  pin: (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <path
        d="M32 6c-8.3 0-15 6.8-15 15.1 0 11.3 14.3 28.7 14.9 29.4l0.1 0.1 0.1-0.1c0.6-0.7 14.9-18.1 14.9-29.4C47 12.8 40.3 6 32 6zm0 21.3c-3.4 0-6.2-2.8-6.2-6.2s2.8-6.2 6.2-6.2 6.2 2.8 6.2 6.2-2.8 6.2-6.2 6.2z"
        fill="currentColor"
      />
    </svg>
  ),
  calendar: (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <path
        d="M50 10h-4V6h-4v4H22V6h-4v4h-4c-3.3 0-6 2.7-6 6v34c0 3.3 2.7 6 6 6h36c3.3 0 6-2.7 6-6V16c0-3.3-2.7-6-6-6zm2 40c0 1.1-0.9 2-2 2H14c-1.1 0-2-0.9-2-2V26h40v24zm0-28H12v-6c0-1.1 0.9-2 2-2h4v4h4v-4h20v4h4v-4h4c1.1 0 2 0.9 2 2v6z"
        fill="currentColor"
      />
    </svg>
  ),
  waves: (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <path
        d="M10 22c3.5 0 5.3-1.9 7-3.5 1.5-1.4 2.7-2.5 5-2.5s3.5 1 5 2.5c1.7 1.6 3.5 3.5 7 3.5s5.3-1.9 7-3.5c1.5-1.4 2.7-2.5 5-2.5s3.5 1 5 2.5c1.7 1.6 3.5 3.5 7 3.5v6c-5 0-7.7-2.6-9.8-4.5-1.4-1.3-2.3-1.9-3.2-1.9s-1.8 0.7-3.2 1.9c-2 1.9-4.8 4.5-9.8 4.5s-7.7-2.6-9.8-4.5c-1.4-1.3-2.3-1.9-3.2-1.9s-1.8 0.7-3.2 1.9c-2 1.9-4.8 4.5-9.8 4.5V22zm0 14c5 0 7.7-2.6 9.8-4.5 1.4-1.3 2.3-1.9 3.2-1.9s1.8 0.7 3.2 1.9c2 1.9 4.8 4.5 9.8 4.5s7.7-2.6 9.8-4.5c1.4-1.3 2.3-1.9 3.2-1.9s1.8 0.7 3.2 1.9c2 1.9 4.8 4.5 9.8 4.5v6c-5 0-7.7-2.6-9.8-4.5-1.4-1.3-2.3-1.9-3.2-1.9s-1.8 0.7-3.2 1.9c-2 1.9-4.8 4.5-9.8 4.5s-7.7-2.6-9.8-4.5c-1.4-1.3-2.3-1.9-3.2-1.9s-1.8 0.7-3.2 1.9c-2 1.9-4.8 4.5-9.8 4.5V36z"
        fill="currentColor"
      />
    </svg>
  ),
  hourglass: (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <path
        d="M48 10V6H16v4h4v10c0 5.2 3.8 9.6 8.7 11.5-4.9 1.9-8.7 6.3-8.7 11.5v10h-4v4h32v-4h-4V43c0-5.2-3.8-9.6-8.7-11.5 4.9-1.9 8.7-6.3 8.7-11.5V10h4zM24 20V10h16v10c0 4.4-3.6 8-8 8s-8-3.6-8-8zm16 24v10H24V44c0-4.4 3.6-8 8-8s8 3.6 8 8z"
        fill="currentColor"
      />
    </svg>
  )
};

const survivalItems = [
  {
    id: 'calories',
    heading: '6,000',
    subheading: 'Kcals Per Day',
    bullets: ['Dehydrated Meals', 'Snacks', 'Peanut Butter'],
    icon: 'nutrition'
  },
  {
    id: 'water',
    heading: '8 Litres',
    subheading: 'Per Day',
    bullets: ['Desalinator', 'Electrolytes', 'Electric vs Manual'],
    icon: 'water'
  },
  {
    id: 'sleep',
    heading: 'What Sleep?',
    subheading: '2 hours on, 1 off',
    bullets: [],
    icon: 'sleep'
  },
  {
    id: 'navigation',
    heading: 'Navigation',
    subheading: '',
    bullets: ['Auto-rudder', 'Weather Router'],
    icon: 'navigation'
  }
];

const extendedIcons = {
  ...icons,
  nutrition: (
    <img src={forkAndSpoon} alt="Fork and spoon" aria-hidden="true" className="nutrition-icon" />
  ),
  water: (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <path
        d="M32 6S14 27 14 38c0 10 8.5 18 18 18s18-8 18-18C50 27 32 6 32 6zm0 44c-6.6 0-12-5.2-12-12 0-5.6 7.3-17.4 12-23.4 4.7 6 12 17.8 12 23.4 0 6.8-5.4 12-12 12z"
        fill="currentColor"
      />
    </svg>
  ),
  sleep: (
    <img src={night} alt="Night" aria-hidden="true" className="sleep-icon" />
  ),
  navigation: (
    <img src={navigator} alt="Navigator" aria-hidden="true" className="navigator-icon" />
  )
};

const ChallengeSection = () => {
  return (
    <section className="section-seamless challenge-section">
      <div className="challenge-hero">
        <div
          className="challenge-hero__content"
        >
          <div className="challenge-hero__header">
            <div className="challenge-title-group">
              <h2 className="challenge-title">
                THE <span>CHALLENGE</span>
              </h2>
              <div className="challenge-title-line"></div>
              <p className="challenge-description">
                To become one of the small number of people to row non-stop across the entire Atlantic Ocean.
              </p>
            </div>
            <a 
              href="https://www.worldstoughestrow.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="challenge-pill"
            >
              THE WORLD&apos;S TOUGHEST ROW
            </a>
          </div>

          <div className="challenge-stats-section">
            <div className="challenge-stats">
              {challengeStats.map((stat) => (
                <div key={stat.id} className="challenge-stat">
                  <div className="challenge-stat__icon">{extendedIcons[stat.icon]}</div>
                  <div className="challenge-stat__info">
                    <div className="challenge-stat__divider" aria-hidden="true"></div>
                    <div className="challenge-stat__content">
                      <span className="challenge-stat__value">{stat.value}</span>
                      <span className="challenge-stat__label">{stat.label}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="challenge-divider challenge-divider--nested"></div>

          <div className="survival-section">
            <h3 className="survival-heading">
              SURVIVING <span>AT SEA</span>
            </h3>
            <div className="survival-grid">
              <div className="survival-items-wrapper">
                {survivalItems.map((item) => (
                  <div key={item.id} className="challenge-stat survival-item">
                    <div className="challenge-stat__icon">{extendedIcons[item.icon]}</div>
                    <div className="challenge-stat__info">
                      <div className="challenge-stat__divider" aria-hidden="true"></div>
                      <div className="challenge-stat__content survival-item__content">
                        <span className="challenge-stat__value">{item.heading}</span>
                        {item.subheading && (
                          <span className="challenge-stat__label survival-item__subheading">
                            {item.subheading}
                          </span>
                        )}
                        {item.bullets.length > 0 && (
                          <ul className="survival-item__list">
                            {item.bullets.map((bullet) => (
                              <li key={bullet}>{bullet}</li>
                            ))}
                          </ul>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="distance-image-section">
        <img src={theDistanceImage} alt="The Distance - Transatlantic Route Map" className="distance-image" />
      </div>
    </section>
  );
};

export default ChallengeSection;
